<template>
  <header class="header-wrap">
    <div class="top">
      <img src="../assets/img/123.png" class="logo" alt="">
      <ul class="nav">
        <li class="nav-item" :class="{active:activeIndex==index}" v-for="(item,index) in navL" :key="index" @mousemove="addActive(index)" @click="activeClick(index)">
          <a>{{ item.name }}</a>
        </li>
      </ul>
      <p v-if="!permission" class="btn" @click="loginClick">登录/注册</p>
      <div v-else>
        <span style="display: flex;align-items: center;justify-content: center;"><img src="../assets/img/person.png" style="height: 30px;margin-right: 10px;" alt=""><span style="font-size: 14px;color:#666;">欢迎，{{ permission.Account }}</span>
          <i class="iconfont icon-chuizhizhixian" style="font-size: 20px;"></i>
          <span style="margin-left: 3px;font-size: 14px;cursor: pointer;color:#666;" @click="quitClick"><i class="iconfont icon-tuichu" style="margin-right: 3px;color:#666;"></i>退出</span></span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      input: '',
      activeIndex: 0,
      navL: [
        { name: '首页', path: '/' },
        { name: '名师风采', path: '/Brand' },
        // { name: '机考入口', path: '/ExamList' },
        // { name: '联考相关', path: '/ExamOutline' },
      ],
      permission: JSON.parse(sessionStorage.getItem('userInfo')) || false,
    }
  },
  mounted() {
    this.navL.map((item, index) => {
      if (item.path === this.$route.path) {
        this.activeIndex = index
      }
    })
  },
  methods: {
    addActive(index) {
      this.activeIndex = index
    },
    loginClick() {
      this.$router.push({
        path: '/Login'
      })
    },
    activeClick(index) {
      // if (index === 0 || index === 1 || index === 2) {
      this.$router.push({
        path: this.navL[index].path
      })
      // } 
      // else if (index === 3) {
      //   this.dialogVisible = true
      // } else {
      //   this.$confirm('退出当前登录?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     customClass: 'del-model',
      //     type: 'warning'
      //   }).then(() => {
      //     sessionStorage.clear()
      //     this.$router.go(0)
      //   }).catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '已取消退出'
      //     });
      //   });
      // }
    },
    quitClick() {
      this.$confirm('退出当前登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'del-model',
        type: 'warning'
      }).then(() => {
        sessionStorage.clear()
        this.$router.go(0)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出'
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.header-wrap {
  width: 100%;
  height: 76px;
  background: #282728;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
  .top {
    max-width: 1206px;
    height: 76px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    .logo {
      height: 66px;
    }
    .logo1 {
      height: 40px;
    }
    .nav {
      width: 50%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 !important;
      list-style: none;
      margin-right: 160px;
      .nav-item {
        margin: 0 45px;
        position: relative;
        white-space: nowrap;
        cursor: pointer;
        a {
          color: #666;
          font-size: 16px;
          font-weight: 400;
          text-decoration: none;
        }
      }
      .active {
        a {
          color: #00be78;
        }
        ::after {
          background: #00be78;
          display: block;
          content: "";
          width: 30px;
          height: 3px;
          border-radius: 2px;
          position: absolute;
          bottom: -15px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
  .btn {
    width: 100px;
    height: 34px;
    color: #00be78;
    border: 1px solid #00be78;
    border-radius: 18px;
    font-size: 14px;
    font-weight: 400;
    line-height: 34px;
    text-align: center;
    cursor: pointer;
  }
}
.dialog {
  ::v-deep .el-dialog__header {
    background-color: #4384f4;
    .dialog-title {
      color: #ffffff;
      i {
        font-size: 18px;
      }
      span {
        font-size: 15px;
      }
    }
  }
  ::v-deep .el-dialog__close {
    color: #ffffff;
    font-size: 16px;
  }
  ::v-deep .el-dialog__footer {
    padding-top: 0;
  }
}
</style>